export async function loadInstalledPlugins(pluginManager) {
  let config;

  try {
    const response = await fetch('/plugins.json');
    if (!response.ok) {
      console.warn('[PluginLoader] No plugins.json found, skipping plugin loading.');
      return;
    }
    const contentType = response.headers.get('content-type') || '';
    if (!contentType.includes('application/json')) {
      console.warn('[PluginLoader] plugins.json returned non-JSON response, skipping.');
      return;
    }
    config = await response.json();
  } catch (err) {
    console.warn('[PluginLoader] Failed to fetch plugins.json:', err);
    return;
  }

  if (!config.installed || !Array.isArray(config.installed)) {
    return;
  }

  for (const entry of config.installed) {
    const { name, source, autoActivate } = entry;

    try {
      let pluginModule;

      if (source === 'local') {
        pluginModule = await import(/* @vite-ignore */ `./local/${name}/index.js`);
      } else {
        pluginModule = await import(/* @vite-ignore */ name);
      }

      const manifest = pluginModule.default || pluginModule;
      const registered = pluginManager.register(manifest);

      if (registered && autoActivate !== false) {
        pluginManager.activate(manifest.name);
      }
    } catch (err) {
      console.error(`[PluginLoader] Failed to load plugin "${name}":`, err);
    }
  }
}
